import React, { HTMLAttributes, PropsWithChildren } from 'react';

import cn from 'classnames';

import css from './styles.css';

export type ScrollContainerProps = PropsWithChildren<Pick<HTMLAttributes<HTMLDivElement>, 'className'>>;

const ScrollContainer = React.forwardRef<HTMLDivElement, ScrollContainerProps>(({ className, children }, ref) => {
    return (
        <div ref={ref} className={cn(css.container, className)}>
            {children}
        </div>
    );
});

ScrollContainer.displayName = 'ScrollContainer';

export { ScrollContainer };
